import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { GrnStatusEnum } from "./dto/grn-status.enum";
import { GrnItems } from "./grn-items.entity";
import { Grn } from "./grn.entity";

@Entity('grn_inspection')
export class GrnInspection{
    @PrimaryGeneratedColumn('increment', {
        name: 'id'
    })
    grnInspectionId: number;

    @Column({
        type: 'enum',
        enum: GrnStatusEnum,
        nullable: false,
        name: 'status'
    })
    status: string;

    @Column('int', {
        name: 'reason_id'
    })
    reasonId: number

    @Column('int', {
        name: 'quantity'
    })
    quantity: number

    @CreateDateColumn({
        name: "created_at",
    })
    createdAt: string;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "created_user",
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
    })
    updatedAt: string;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user",
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag",
    })
    versionFlag: number;

    @ManyToOne(type => GrnItems, grn => grn.grninspection)
    @JoinColumn({ name: 'grn_item_id' })
    grnitemId: GrnItems

    @ManyToOne(type => Grn, grn => grn.grninspection)
    @JoinColumn({ name: 'grn_id' })
    grnId: Grn
}